import gql from 'graphql-tag';

export const RefundSale = gql`
  mutation RefundSale($input: RefundSaleInput!) {
    refundSale(input: $input) {
      msgSentToQueue
    }
  }
`;
